
/**
 * Utility functions for handling image URLs
 */

// Get the preview base URL from environment variables or use a fallback
// Using a hardcoded fallback URL if the environment variable is not set
const PREVIEW_BASE_URL = import.meta.env.VITE_PREVIEW_BASE_URL || 'https://bcknd.artuba.com/preview/';

// Log the base URL for debugging purposes
console.log('Preview Base URL:', PREVIEW_BASE_URL);

/**
 * Generates a complete preview URL by combining the base URL with the image filename
 * @param preview The preview image filename from the database
 * @returns The complete URL for the preview image
 */
export const getPreviewUrl = (preview: string | null): string => {
  if (!preview) return '';
  
  // Log the incoming preview value for debugging
  console.log('Processing preview:', preview);
  
  // Check if the preview already includes http(s):// - in that case it's already a full URL
  if (preview.startsWith('http://') || preview.startsWith('https://')) {
    return preview;
  }
  
  // Make sure the base URL has a trailing slash if needed
  const baseUrl = PREVIEW_BASE_URL.endsWith('/') ? PREVIEW_BASE_URL : `${PREVIEW_BASE_URL}/`;
  const fullUrl = `${baseUrl}${preview}`;
  
  // Log the generated full URL for debugging
  console.log('Generated URL:', fullUrl);
  
  return fullUrl;
};
